module.exports = __webpack_public_path__ + "media/main-video.16c54d9e.webm";